export default __webpack_public_path__ + "static/media/JURISERA_Logo-011.d04a9af8.svg";